import React, { useRef, useState, useEffect } from 'react';
import ScalamentoWordMark from '../svgs/ScalamentoWordmark';
import settings from '../config/settings';

import { useTranslation } from 'react-i18next';
import { loadLanguage } from '../config/i18n';
import { scrollToSection } from '../utils/scrollUtils';
import { Link, useLocation } from 'react-router-dom';

function NavBarDesktop() {
  const { i18n, t } = useTranslation();
  const navBarRef = useRef(null);
  const [activeSection, setActiveSection] = useState('why');
  const location = useLocation();

  const changeLanguage = (lng) => {
    loadLanguage(lng);
  };
  
  function renderNavItem() {
    return settings.navBar.navSections.map(section => {
      const isLink = location.pathname === '/privacy' || location.pathname === '/imprint';
      const Element = isLink ? Link : 'a';
      const props = {
        className: `navbar-item-${section} byrd-m-l ${activeSection === section ? `highlighted` : ''}`
      };
  
      if (isLink) {
        props.to = `/#${section}`;
      } else {
        props.href = `#${section}`;
        props.onClick = (e) => scrollToSection(e, { mobile: false });
      }
  
      return (
        <Element key={section} {...props}>
          {t(`NavBar.NavItem.${section.charAt(0).toUpperCase() + section.slice(1)}`)}
        </Element>
      );
    });
  }
  
  function renderLanguageButton() {
    return settings.navBar.languages.map(language => (
      <button
        key={language}
        className={`byrd-m-l navbar-language-button ${i18n.language === language ? 'navbar-language-button-selected' : ''}`}
        onClick={() => changeLanguage(language)}
      >
        {t(`NavBar.NavItem.Language.${language.charAt(0).toUpperCase() + language.slice(1)}`)}
      </button>
    ));
  }
  
  function renderLogo() { 
    const isLink = location.pathname === '/privacy' || location.pathname === '/imprint';
    const Element = isLink ? Link : 'a';
    const props = {
      className: 'navbar-logo',
      'aria-label': t('NavBar.NavItem.Home')
    };
  
    if (isLink) {
      props.to = "/";
    } else {
      props.href = "/";
    }
  
    return (
      <Element key="logo" {...props}>
        <ScalamentoWordMark />
      </Element>
    );   
  }

  function renderWriteUsButton() {
    const isLink = location.pathname === '/privacy' || location.pathname === '/imprint';
    const Element = isLink ? Link : 'a';
    const props = {
      className: `navbar-writeus navbar-writeus-button byrd-s-xb ${activeSection === 'writeus' ? 'navbar-writeus-button-highlighted' : ''}`,
      'aria-label': t('NavBar.ContactButton')
    };
  
    if (isLink) {
      props.to = "/#writeUs";
    } else {
      props.href = "#writeUs";
      props.onClick = (e) => scrollToSection(e, { mobile: false });
    }
  
    return (
      <Element key="writeUs" {...props}>
        {t('NavBar.ContactButton')}
      </Element>
    );
  } 

  // Hook for scrolling events
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        navBarRef.current.classList.add('navbar-fixed-nav');
      } else {
        navBarRef.current.classList.remove('navbar-fixed-nav');
      }
  
      let active = '';
      settings.navBar.navSections.forEach(section => {
        const element = document.getElementById(section);
        if (element && element.getBoundingClientRect().top < window.innerHeight * 0.5) {
          active = section;
        }
      });
      setActiveSection(active || 'why');
    };
  
    // Initial call to handleScroll to set 'why' active if not scrolled
    handleScroll();
  
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav aria-label={t('NavBar.Label')} className="navbar-desktop">
      <div ref={navBarRef} className='navbar module' id="navBar">
        <div className='navbar-container'>
            <div className="navbar-logo"> 
              {renderLogo()}
            </div>
            <div className='navbar-navigation'>
              {renderNavItem()}
            </div>
            <div className="navbar-language">
              {renderLanguageButton()}
            </div>
            <div className="navbar-write-us">
              {renderWriteUsButton()}
            </div>
        </div>
      </div>
    </nav>
  );
}

export default NavBarDesktop;
